import { StoreState } from '../../types';

export const getIsNotificationsFetched = (store: StoreState): boolean => store.notifications.isFetched;
export const getIsNotificationsLoading = (store: StoreState): boolean => store.notifications.isLoading;
export const getIsNotificationsFetching = (store: StoreState): boolean => store.notifications.isFetching;
export const getNotificationsErrors = (store: StoreState) => store.notifications.errors;
export const getNotifications = (store: StoreState) => store.notifications.notifications;